import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = ['link', 'sentinel'];

  connect() {
    this.triggered = false;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
      },
      { rootMargin: '200px' },
    );
    this.observer.observe(this.sentinelTarget);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  async loadMore(event) {
    event?.preventDefault();
    if (this.triggered) return;

    this.triggered = true;
    const label = this.linkTarget.textContent;
    this.linkTarget.setAttribute('aria-busy', 'true');
    this.linkTarget.textContent = 'Wczytywanie…';

    try {
      const response = await fetch(this.linkTarget.href, {
        headers: { Accept: 'text/vnd.turbo-stream.html' },
      });
      if (!response.ok || response.redirected) throw new Error(response.status);

      Turbo.renderStreamMessage(await response.text());
    } catch {
      this.triggered = false;
      this.linkTarget.removeAttribute('aria-busy');
      this.linkTarget.textContent = label;
    }
  }
}
